import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../../../../_metronic/_partials/controls";
import { useFormik } from "formik";

import * as Yup from "yup";
import * as lineActions from "../../../_redux/orderlines/orderlinesActions";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ErrorDialog } from "../../../../../../_metronic/_partials/controls/ErrorDialog";
import { toast } from "react-hot-toast";

export function OrderProductCard({ product }) {
  const initialValues = {
    qty: product.minAmount !== 0 ? product.minAmount : 1,
  };

  const { lineActionLoading } = useSelector((state) => ({
    lineActionLoading: state.orderlines.actionsLoading,
  }));

  const { lastOrder } = useSelector(
    (state) => ({
      lastOrder: state.orders.lastOrder,
      lineActionLoading: state.orderlines.actionsLoading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const productCardSchema = Yup.object().shape({
    qty: Yup.number()
      .required()
      .test("check-selected-qty", function(value) {
        debugger;
        if (product.minAmount !== 0) {
          if (value < product.minAmount) {
            return this.createError({
              path: "qty",
              message: "مقدار درخواستی شما کمتر از حداقل تعداد سفارش است.",
            });
          }
        }
        if (product.maxAmount !== 0) {
          if (value > product.maxAmount) {
            return this.createError({
              path: "qty",
              message: "مقدار درخواستی شما بیشتر از حداکثر مقدار سفارش میباشد.",
            });
          }
        }

        return true;
      }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: productCardSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(
        lineActions.createOrderline({
          orderId: lastOrder.id,
          productId: product.id,
          qty: values.qty,
        })
      )
        .then(() => {
          toast.success("محصول انتخابی شما ثبت شد");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          formik.setFieldError("qty", error.response.data.message);
        });
    },
  });

  return (
    <Card className={"border border-primary h-100"}>
      <CardHeader title={product.name} />

      <CardBody>
        {/*<p>*/}
        {/*    <span>موجودی: </span> <b>{product.count} {product.unit}</b>*/}
        {/*</p>*/}
        <p>
          <span>قیمت: </span>
          <b>{product.price.toLocaleString()} ریال</b>
        </p>
        <p>
          <span>حداقل تعداد سفارش: </span>
          <b>{product.minAmount}</b>
        </p>
        <p>
          <span>حداکثر تعداد سفارش: </span>
          <b>{product.maxAmount}</b>
        </p>
        {product.ratio !== 0 && (
          <p>
            <span>ضریب سفارش: </span>
            <b>{product.ratio}</b>
          </p>
        )}
      </CardBody>
      {product.minAmount !== 0 && product.maxAmount !== 0 && (
        <CardFooter>
          <form onSubmit={formik.handleSubmit}>
            <div className={"mb-4 d-flex align-items-center"}>
              <button
                type={"button"}
                onClick={() =>
                  formik.setFieldValue("qty", formik.values.qty + 1)
                }
                className={"btn btn-success mr-3"}
              >
                <span className="svg-icon svg-icon-md svg-icon-white mr-0">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")} />
                </span>
              </button>
              <input
                type={"number"}
                className={"form-control mr-3"}
                {...formik.getFieldProps("qty")}
              />
              <button
                type={"button"}
                onClick={() =>
                  formik.setFieldValue(
                    "qty",
                    formik.values.qty <= 1 ? 1 : formik.values.qty - 1
                  )
                }
                className={"btn btn-danger"}
              >
                <span className="svg-icon svg-icon-md svg-icon-white mr-0">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Minus.svg")} />
                </span>
              </button>
            </div>
            {formik.errors.qty ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.qty}</div>
              </div>
            ) : null}
            {product.ratio !== 0 && (
              <div>
                <p className={"text-muted"}>
                  <span>مقدار نهایی سفارش: </span>
                  <b>
                    {formik.values.qty * product.ratio} {product.unit}
                  </b>
                </p>
              </div>
            )}

            <button
              type={"submit"}
              disabled={lineActionLoading}
              className={"btn btn-primary"}
            >
              {lineActionLoading ? (
                <>لطفا منتظر بمانید...</>
              ) : (
                <>افزودن به لیست سفارش</>
              )}
            </button>
          </form>
        </CardFooter>
      )}
    </Card>
  );
}
